import { useState } from "react";
import { Modal, Input, Button } from "antd";
import { useTranslation } from "react-i18next";
import { createTicket } from "../helpCenter.service";

type Props = {
  open: boolean;
  projectId?: string;
  onClose: () => void;
  onCreated: () => void;
};

const AddTicketModal = ({
  open,
  onClose,
  onCreated,
}: Props) => {
  const { t } = useTranslation("helpCenter");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({});

  const validate = () => {
    const e: Record<string, string> = {};
    if (!email.trim()) e.email = t("addModal.emailRequired");
    if (!description.trim()) e.description = t("addModal.descriptionRequired");
    return e;
  };

  const handleSubmit = async () => {
    const e = validate();
    if (Object.keys(e).length) {
      setErrors(e);
      return;
    }
    setLoading(true);
    try {
      await createTicket({
        ticket_type: "team_support",
        email: email.trim(),
        subject: subject.trim() || undefined,
        description: description.trim(),
      });
      handleClose();
      onCreated();
    } catch {
      // handled by interceptor
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setEmail("");
    setSubject("");
    setDescription("");
    setErrors({});
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={null}
      centered
      width={480}
      className="add-ticket-modal"
      title={<div className="add-ticket-modal-title">{t("addModal.title")}</div>}
    >
      <div className="add-ticket-form">
        <div className="form-field">
          <label>{t("addModal.emailLabel")}</label>
          <Input
            placeholder={t("addModal.emailPlaceholder")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            status={errors.email ? "error" : undefined}
          />
          {errors.email && <span className="field-error">{errors.email}</span>}
        </div>

        <div className="form-field">
          <label>{t("addModal.summaryLabel")}</label>
          <Input
            placeholder={t("addModal.summaryPlaceholder")}
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
        </div>

        <div className="form-field">
          <label>{t("addModal.descriptionLabel")}</label>
          <Input.TextArea
            rows={4}
            placeholder={t("addModal.descriptionPlaceholder")}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            status={errors.description ? "error" : undefined}
          />
          {errors.description && (
            <span className="field-error">{errors.description}</span>
          )}
        </div>

        <div className="add-ticket-modal-actions">
          <Button onClick={handleClose}>{t("addModal.cancel")}</Button>
          <Button
            className="add-ticket-button-modal"
            onClick={handleSubmit}
            loading={loading}
          >
            {t("addModal.submit")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AddTicketModal;
